module.exports = __webpack_public_path__ + "static/media/metafest-header2.5321202d.png";